import { render, staticRenderFns } from "./parametres.html?vue&type=template&id=38ab2271&scoped=true&external"
import script from "./parametres.js?vue&type=script&lang=js&external"
export * from "./parametres.js?vue&type=script&lang=js&external"
import style0 from "./parametres.scss?vue&type=style&index=0&id=38ab2271&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab2271",
  null
  
)

export default component.exports